export default "__VITE_ASSET__D7upu0Y4__"